// extracted by mini-css-extract-plugin
module.exports = {"globalFooter":"styles_globalFooter__3MNrT"};